import { useEffect, useState } from "react";
import { useParams } from "react-router-dom"
import axios from "axios";
import { useAuthContext } from "../../hooks/useAuthContext";
import MessageBoxModal from "./modals/MessageBoxModal";
import { ApiConnectionString } from "../../constants/ApiConntection";


export default function OneUser() {
    const { id } = useParams();
    const [appUser,setAppUser] = useState("");
    const [loading,setLoading] = useState(true)
    const { user } = useAuthContext();
    

// Bool for the send messeage modal
  const [activeModal,setActiveModal] = useState(false)

  //Get the Users Date
    useEffect(() => {
        setLoading(true);
        axios
          .get(`${ApiConnectionString}/api/user/${id}`,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          })
          .then((response) => {
            setAppUser(response.data);
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
          });
      }, [id,user]);

      //Exit the Send message Screen
      const cancelModal = (e) => {
        e.preventDefault();
        setActiveModal(false)
      }

  return (
    <div className="container">{appUser.username}
    <button onClick={() => setActiveModal(true)}>Send Message</button>
    {activeModal && <MessageBoxModal receiverName={appUser.username} receiverId={appUser.id} cancelModal ={cancelModal }/>}
  
   
    </div>
  )
}
